module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    class: {
      error: _vm.isError
    },
    attrs: {
      "id": "clonar-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "clonar-modal-body"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mapa.nomAplicacio))]), _vm._v(" "), _c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.nom),
      expression: "form.nom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "name": "nom",
      "type": "text",
      "data-vv-validate-on": "blur",
      "placeholder": _vm.$t('newMapNom')
    },
    domProps: {
      "value": (_vm.form.nom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "nom", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('nom')),
      expression: "errors.has('nom')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('formValidation')))])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.clonarMapa
    }
  }, [_vm._v(_vm._s(_vm.$t('duplicar')))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "clonar-modal-msg"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('messageDuplicate')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "clonar-modal-msg2"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('title')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('messageNoLogat')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da2909e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gallery/components/clonar-modal/clonar-modal.vue
// module id = 325
// module chunks = 0